import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "NewsletterSubscribe" })
export default class NewsletterSubscribe extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public subscribeData: any = null;
    public formData: any = {};
    public interests: any[] = [];
    public profileSegments: any[] = [];
    public validationErrors: any[] = [];

    get isNewsletterSubscribeVisible() {
        return this.$store.getters["newsletterStore/isNewsletterSubscribeVisible"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly recaptchaSiteKey: string;

    @Watch("isNewsletterSubscribeVisible") async onNewsletterSubscribeVisibilityUpdate(newValue: boolean) {
        if (newValue) {
            await this.getData();
            this.setRecapthca();

            document.body.classList.add("overflow");
            (<any>this).$refs.newsletterSubscribeModal.classList.add("show");
        } else {
            document.body.classList.remove("overflow");
            (<any>this).$refs.newsletterSubscribeModal.classList.remove("show");
        }
    }

    public async created() {
        this.setOpenNewsletterDialog();
    }

    public setRecapthca() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public async getData() {
        this.subscribeData = (await Axios.post(this.routes.Newsletter_GetNewsletterSubscribeData, null)).data;
        this.interests = this.subscribeData.interests;

        this.formData.interests = this.interests.map((x: { value: any; }) => x.value);
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.Newsletter_NewsletterSubscribe, this.formData, { headers: { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } });

            this.isSuccess = true;

            GTagHelper.sendEvent("form_submit", "newsletter_subscribe");
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        (<any>window).grecaptcha.reset();

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }

    public closeNewsletterSubscribe() {
        this.$store.commit("newsletterStore/setNewsletterSubscribeVisible", false);
        this.isLoading = false;
        this.isSuccess = false;
        this.formData = { profileSegment: null };
        this.validationErrors = [];
    }

    public setOpenNewsletterDialog() {
        if (this.isNewsletterSubscribeVisible) {
            return;
        }
        else if (this.$route.query.hasOwnProperty("IsNewsletter")){
            this.$store.commit("newsletterStore/setNewsletterSubscribeVisible", true);
        } 
    }
};